export default __webpack_public_path__ + "static/media/logo.33125662.svg";